import ResourcesCollectionProto from "./resources-collection-proto"
import TaskUpdate from "../../../app/home/notifications/model/models/task/task-update"
import Resources from "../resources";

export default class TaskUpdatesResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, TaskUpdate, options)
    }
}